import { memo } from 'react';
import { useSelector } from 'react-redux';

import { ContentHeaderTitle } from '~/components/PageHeader/ContentHeaderTitle';
import { usePublicCustomColors } from '~/hooks/usePublicCustomColors';
import { centralizedBoardTitleSelector } from '~/store/centralizedBoard/selectors';

export const PublicBoardHeaderTitle = memo(() => {
  const title = useSelector(centralizedBoardTitleSelector);
  const { headlineColor } = usePublicCustomColors();

  if (!title) {
    return null;
  }

  return (
    <ContentHeaderTitle data-testid="BOARD_BLURB_TITLE" style={headlineColor ? { color: headlineColor } : undefined}>
      {title}
    </ContentHeaderTitle>
  );
});

PublicBoardHeaderTitle.displayName = 'PublicBoardHeaderTitle';
